import { createContext, useContext, useState, useEffect } from "react";

// Create Context
const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [user, setUser] = useState(null);     
    const [loading, setLoading] = useState(true); 

    const apiURL = import.meta.env.VITE_API;

    // AuthContext.js
    const checkAuth = async () => {
        try {
            // const res = await fetch(`${apiURL}/account/verify-token`, {
            const res = await fetch(`${apiURL}/account/verify-token`, {
                method: "GET",
                credentials: "include"
            });

            if (res.ok) {
                const userData = await res.json();
                setUser(userData);
                setIsAuthenticated(true);
            } else {
                setUser(null);
                setIsAuthenticated(false);
            }

        } catch {
            setUser(null);
            setIsAuthenticated(false);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        checkAuth();
    }, []);

    useEffect(() => {
        checkAuth();
    }, [location.pathname]);

    const login = async (userData) => {
        setUser(userData);
        setIsAuthenticated(true);
        checkAuth();
    };


    const logout = async () => {
        //await fetch(`/api/account/logout`, {
        await fetch(`${apiURL}/account/logout`, {
            method: "POST",
            credentials: "include"
        });

        setUser(null);
        setIsAuthenticated(false);
    };

    return (
        <AuthContext.Provider value={{ isAuthenticated, user, login, logout, loading }}>
            {children}
        </AuthContext.Provider>
    );
};
